export enum EngineName {
  NATIVE = "web-native",
  HLS_JS = "hls.js",
  SHAKA = "shaka-player",
}
